<template>
    <section>
        <div class="contact_section6" style="padding-bottom: 267px;">
            <div class="con_wrap">
                <p style="font-size: 35px; font-weight: 700; color: black; line-height: 1.5; margin-bottom: 56px;">자주 묻는 질문</p>
                <div style="display: flex; flex-direction: column; margin-bottom: 37px">
                    <div @click="openMenu(index)" class="list" v-for="(item, index) in qna" :key="index" style="display: flex; flex-direction: column; border-bottom: 1px solid #E7E7E7; padding: 30px 5px;">
                        <div class="title" style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                            <p style="font-size: 20px; color: #2C2C2C; font-weight: 400;">{{item.title}}</p>
                            <img src="@/assets/images/main_v2/icon/arrow_down.svg" alt="" :style="{transform: 'rotate(' + (item.state ? 180 : 0) + 'deg)'}" style="width: 17px; transition: all 0.3s ease;">
                        </div>
                        <div :style="{height: (item.state ? 'auto' : 0), opacity: (item.state ? 1 : 0)}"  style="transition: all 0.3s ease; overflow: hidden;">
                            <p style="font-size: 20px; color: #737373; font-weight: 400; margin-top: 26px; line-height: 1.5;">{{item.detail}}</p>
                        </div>
                    </div>
                    <!-- <div @click="openMenu(index)" class="list" v-for="(item, index) in qna" :key="index" style="display: flex; flex-direction: column; border-bottom: 1px solid #E7E7E7; padding: 13px 5px;">
                        <div class="title" style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                            <p style="font-size: 18px; color: #2C2C2C; font-weight: 400;">{{item.title}}</p>
                            <img src="@/assets/images/main_v2/icon/arrow_down.svg" alt="" :style="{transform: 'rotate(' + (item.state ? 180 : 0) + 'deg)'}" style="width: 17px; transition: all 0.3s ease;">
                        </div>
                        <div :style="{height: (item.state ? 'auto' : 0), opacity: (item.state ? 1 : 0)}"  style="transition: all 0.3s ease; overflow: hidden;">
                            <p style="font-size: 16px; color: #737373; font-weight: 400; margin: 26px 0; line-height: 1.5;">{{item.detail}}</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar,
    },
    data() {
        return {
            activeIndex: -1,
            qna: [
                {
                    'title': '과거 지원한 이력이 있는 경우 재지원이 가능한가요?',
                    'detail': '네, 재지원 가능합니다. 다만, 동일한/유사한 포지션에 재지원하시는 경우에는 전형 결과를 안내 받으신 시점으로부터 6개월이 지난 이후 재지원 부탁드립니다.',
                    'state': false
                },{
                    'title': '이메일로도 지원이 가능한가요?',
                    'detail': '가급적 채용공고 페이지를 통해 지원부탁드립니다. 이메일로 지원은 가능하지만, 확인을 하지 못하는 경우가 있을 수 있습니다. 이와 같은 경우를 방지하기 위함이니 양해부탁드립니다.',
                    'state': false
                },{
                    'title': '용량이 큰 파일(이력서, 포트폴리오 등)을 이메일로 제출할 수 있나요?',
                    'detail': '네, 가능합니다. 다만, 채용공고 페이지에서 지원을 할 때 이에 관한 내용을 반드시 기재해주셔야 확인하는데 문제가 생기지 않을 수 있으니, 이 점 유의해주시기 바랍니다',
                    'state': false
                },{
                    'title': '인터뷰 결과에 대한 안내는 언제 받을 수 있나요?',
                    'detail': '인터뷰 결과에 대해서는 늦어도 2주 안으로 안내드리고 있습니다. 합격자에 한해 안내를 드리고 있으니 이점 확인하 시어 지원해주시기 바랍니다.',
                    'state': false
                },{
                    'title': '졸업증명서, 경력증명서 등 증빙서류는 언제 제출하나요?',
                    'detail': '졸업증명서, 경력증명서의 경우에는 합격자에 한해 별도의 안내를 드리고 있습니다. 증빙서류가 필요한 경우 안내드릴 예정이니, 확인하시고 필요한 증빙서류를 첨부해주시면 됩니다.',
                    'state': false
                },{
                    'title': '프리랜서, 외주 등의 경력도 인정해주나요?',
                    'detail': '경력에 대해서 인정을 하고 있지는 않으나, 프리랜서나 외주라도 경력만 있다면 기재해주시면 인터뷰에서 판단하기에 도움이 될 수 있으니 기재해주시면 좋습니다.',
                    'state': false
                },{
                    'title': '불합격 사유에 대해 알 수 있나요?',
                    'detail': '불합격 사유에 대해서는 안내드리고 있지 않습니다. 이 점 양해바랍니다.',
                    'state': false
                },
            ],
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        openMenu(val) {
            this.$set(this.qna[val], 'state' , !this.qna[val].state)
            if(this.qna[val].state) {
                var index = this.qna.findIndex((item) => {
                    return item.state && (item != this.qna[val])
                })
                if(index != -1) {
                    this.$set(this.qna[index], 'state' , false)
                }
            }
        },
        changeRow(val) {
            return val.split('\n').join('<br />')
        },
        setIcon(val)  {
            return require('@/assets/images/main_v2/icon/'+ val.icon +'.svg')
        }
    },
}
</script>
<style>
    .contact_section6 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    .contact_section6 .swiper-wrapper {
        transition-timing-function: linear
    }
    .contact_section6 .inActive {
        padding: 4px 14px;
        color: #2C2C2C;
        font-weight: 700;
        font-size: 18px;
        border-radius: 100px;
        margin-right: 20px;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    .contact_section6 .isActive {
        background: #1C9CD3;
        color: white
    }
    .contact_section6 .list:hover {
        background: #E7E7E7;
        cursor: pointer;
    }
</style>